module.exports = __webpack_public_path__ + "static/fonts/FANGZHENGSHUSONGFANTI-1_0.6eec8ad.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/suft/FANGZHENGSHUSONGFANTI-1_0.woff
// module id = VtW+
// module chunks = 2